import React, { FunctionComponent, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { IBindingCallback1 } from '../../../../common/models/callback';
import RegularButton from '../../../../components/RegularButton';
import { IQuestionForReference } from '../../../../common/models/question/IQuestionForReference';
import { IExtraQuestion } from '../../../../common/models/question/IExtraQuestion';
import TextArea from '../../../../components/TextArea';
import Icon from '../../../../components/Icon';
import { formatQuestionText } from '../../containers/QuestionsContainer/utils';
import styles from './styles.module.scss';

const MAX_ANSWER_LENGTH = 2000;

interface IQuestionProps {
  isPreview: boolean;
  question: IQuestionForReference | IExtraQuestion;
  candidateFirstName: string;
  onAnswer: IBindingCallback1<IQuestionForReference | IExtraQuestion>;
}

const FreeResponseQuestion: FunctionComponent<IQuestionProps> = ({
  question,
  isPreview,
  candidateFirstName,
  onAnswer
}) => {
  const [answer, setAnsver] = useState(question.answer);
  const answerLength = answer?.length || 0;

  return (
    <div className="d-flex flex-column survey-page-wrapper">
      <p className="survey-page-title">{formatQuestionText(question.text, candidateFirstName)}</p>
      <FormattedMessage id="survey.placeholder" defaultMessage="Please provide at least a few sentences">
        {(placeholder: string) => (
          <div className={styles.textareaBlock}>
            <TextArea
              input={answer}
              placeholder={placeholder}
              onChange={val => setAnsver(val)}
            />
          </div>
        )}
      </FormattedMessage>
      <div className="mt-4 d-flex justify-content-end">
        <RegularButton
          size="lg"
          disabled={!isPreview && (!answer?.trim() || MAX_ANSWER_LENGTH < answerLength)}
          textIntlId="continue"
          defaultMessage="Continue"
          onClick={() => onAnswer({ ...question, answer })}
          icon={<Icon icon="arrowRight" />}
          iconPosition="right"
        />
      </div>
    </div>
  );
};

export default FreeResponseQuestion;
